const DEFAULT_TITLE = 'Spotahome';
const FIRST_PAGE = 1;

const getTitle = title =>
  title ? `${title} | ${DEFAULT_TITLE}` : DEFAULT_TITLE;

const formatRef = id => `(ref: ${id})`;

export const getPageTitleFromSeo = (metadata = {}) => {
  const { title } = metadata.basic || {};
  return getTitle(title);
};

export const getSearchPageTitle = (metadata = {}, page = FIRST_PAGE) => {
  const { title } = metadata.basic || {};
  const composedTitle = page === FIRST_PAGE ? title : `${title} ${page}`;
  return getTitle(composedTitle);
};

export const getPageTitleForRentableUnit = (listingTitle, id) => {
  const title = listingTitle ? `${listingTitle} ${formatRef(id)}` : '';
  return getTitle(title);
};

export default {
  getPageTitleFromSeo,
  getSearchPageTitle,
  getPageTitleForRentableUnit
};
